import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from 'react-helmet-async';
import "../assets/styles/NotFound.css";
import notFoundImage from "../assets/images/404-error.jpg"

const NotFound: React.FC = () => {
  return (
    <>
      <Helmet>
        {/* <!-- Primary Meta Tags for SEO --> */}
        <title> 404 – Page Not Found – BuddyTech Solutions </title>
        <meta name="description" content="Oops! This page doesn't exist. Head back to safety or explore other services." />
        <meta name="keywords" content="404, not found, page missing" />

        {/* <!-- Open Graph / Facebook Meta Tags --> */}
        <meta property="og:title" content="404 – Page Not Found – BuddyTech Solutions" />
        <meta property="og:description" content="Oops! This page doesn't exist. Head back to safety or explore other services." />
        <meta property="og:keywords" content="404, not found, page missing" />
        <meta property="og:image" content="https://buddytechsolutions.in/assets/images/thumbnailimages.jpg" />
        <meta property="og:url" content="https://buddytechsolutions.in/ (404)*" />
        <meta property="og:type" content="website" />

        {/* <!-- Optional: Facebook App ID --> */}
        {/* <!-- <meta property="fb:app_id" content="your_facebook_app_id" /> --> */}

        {/* <!-- Twitter Meta Tags --> */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="404 – Page Not Found – BuddyTech Solutions" />
        <meta name="twitter:description" content="Oops! This page doesn't exist. Head back to safety or explore other services." />
        <meta name="twitter:keywords" content="404, not found, page missing" />
        <meta name="twitter:image" content="https://buddytechsolutions.in/assets/images/thumbnailimages.jpg" />
      </Helmet>
      <div className="notfound-container">
        <img src={notFoundImage} alt="404 - Page Not Found" className="notfound-image" />
        {/* <h1 className="notfound-title">404</h1> */}
        <p className="notfound-message">Oops! The page you're looking for doesn't exist.</p>
        <Link to="/" className="notfound-button">Go to Homepage</Link>
      </div>
    </>

  );
};

export default NotFound;
